import { createApp } from 'vue'

import { createPinia } from 'pinia'
import router from '@/router'
import { registerNotFoundRoutes } from '@ontrack/router/notFoundRoutes'

import { createAoI18n } from '@ao/i18n'

import '@/components/ui/chart.js'
import { clientStorageSession, clientStorageLocal } from '@ao/utils'

import { initSentry } from '@ao/monitoring'

import App from '@ontrack/App.vue'

import vuetify from '@/plugins/vuetify'
import { loadFonts } from '@/plugins/webfontloader'

import { install as installAoUI } from '@ao/ui'
import { registerGlobalComponents } from '@/globalComponents.js'
import { registerOntrackComponents } from '@ontrack/ontrackComponents'

import supportedLocales from '@ontrack/config/supported-locales'

loadFonts()

async function initApp() {
	const app = createApp(App)
	app.use(createPinia())

	// До подключения роутера: при подключении он разбирает стартовый адрес
	registerNotFoundRoutes(router)
	app.use(router)

	const i18nPlugin = await createAoI18n({
		appLocaleModules: import.meta.glob('@/assets/locales/*.json'),
		fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || 'ru',
		supportedLocales: supportedLocales,
	})
	app.use(i18nPlugin)

	app.config.globalProperties.$clientStorage = clientStorageLocal
	app.config.globalProperties.$clientSession = clientStorageSession
	app.use(vuetify)

	installAoUI(app)
	registerGlobalComponents(app)
	registerOntrackComponents(app)

	initSentry(app, {
		dsn: import.meta.env.VITE_SENTRY_DSN,
		environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
		release: import.meta.env.VITE_SENTRY_RELEASE,
	})

	app.mount('#app')
}

initApp()
